import HttpService from '../common/http/HttpService';
import ComponentSelectionEndpoint from './componentSelectionEndpoint';

async function getComponentSelection(systemId, componentType) {
  return HttpService.post(
    ComponentSelectionEndpoint.GET_COMPONENT_SELECTION,
    { systemId, componentType },
  );
}

async function setComponentSelection(systemId, checkboxArray, componentType) {
  await HttpService.post(
    ComponentSelectionEndpoint.SET_COMPONENT_SELECTION,
    { systemId, checkboxArray, componentType },
  );
}

const ComponentSelectionService = {
  getComponentSelection,
  setComponentSelection,
};

export default ComponentSelectionService;
